//имена продакшн серверов
export const prodServerName = ['atez.ru'];

//имена дев серверов
export const devServerName = ['test.atez.ru', 'localhost'];

export const showPriceLogo = true;